var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 60,
    viewBox: "0 0 65 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4029 17.7108C14.3367 18.9037 13.6288 21.5457 14.8217 23.6118L21.0779 34.4479C21.6744 35.481 21.3204 36.802 20.2873 37.3985C19.2543 37.9949 17.9333 37.6409 17.3368 36.6079L11.0806 25.7718C8.69481 21.6395 10.1107 16.3555 14.243 13.9697L24.0726 8.29455C28.2049 5.90876 33.4889 7.3246 35.8747 11.4569L42.1309 22.293C42.7273 23.3261 42.3734 24.6471 41.3403 25.2435C40.3072 25.84 38.9862 25.486 38.3898 24.4529L32.1336 13.6169C30.9407 11.5507 28.2987 10.8428 26.2325 12.0357L16.4029 17.7108Z",
    fill: "url(#paint0_linear_4691_20140)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7076 13.9287C44.1425 13.1003 45.9773 13.5919 46.8057 15.0268L62.7911 42.7142C63.6191 44.149 63.1277 45.984 61.693 46.8123L28.7866 65.8108C27.3518 66.6392 25.517 66.1473 24.6885 64.7128L8.70312 37.0253C7.8747 35.5904 8.36632 33.7557 9.8012 32.9272L42.7076 13.9287ZM27.9127 34.3852C27.6257 34.5509 27.5267 34.9178 27.6924 35.2047L30.6333 40.2986C30.799 40.5855 31.1667 40.6841 31.4537 40.5184L32.4263 39.9569C32.7132 39.7913 33.0797 39.8894 33.2454 40.1763L37.7722 48.0171C37.9379 48.3041 38.3057 48.4026 38.5927 48.2369L41.5739 46.5157C41.8607 46.35 41.9585 45.9827 41.7928 45.6958L37.266 37.8551C37.1003 37.5681 37.1993 37.2012 37.4863 37.0355L38.458 36.4745C38.7449 36.3087 38.8427 35.9414 38.677 35.6545L35.7361 30.5607C35.5704 30.2738 35.204 30.1757 34.917 30.3412L27.9127 34.3852Z",
    fill: "url(#paint1_linear_4691_20140)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4691_20140",
    x1: 30.8138,
    y1: 31.321,
    x2: 19.1578,
    y2: 11.1321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEBF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4691_20140",
    x1: 31.4159,
    y1: 32.3624,
    x2: 52.1448,
    y2: 55.9075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.06040bd95f5391020c7f1a3ab7649525.svg";
export { ForwardRef as ReactComponent };